import { Routes, Route } from 'react-router';
import UserManagement from './user/user_management';
import SystemToken from './system/update_token';
import UserInfo from './user/info';
import CheatBan from './user/cheat_ban';
import CheatBanTable from './user/cheat_ban_table';
import CheatProcessData from './cheat/process_data';
import SuspiciousInfoPage from './cheat/suspicious_info';
import CheatUserTeammateCount from './cheat/user_teammate_count';
import LadderLimit from './user/ladder_limit';
import AutoBanStatus from './user/auto_ban/auto_ban_status';
import UserListByUUID from './user/auto_ban/user_list_by_uuid';
import SensitiveRiskPage from './user/sensitive_risk';
import MpqManager from './system/mpq';
import GrayConfigPage from './system/gray_config';
import ReplayCollectPage from './replay/collect';
import ReplayGameNameLookupPage from './replay/game_name_lookup';
import UpdateManagerPage from './update';
import { useStore } from '@nanostores/react';
import authState from './auth_state';

function RenderUserGuide() {
  const authData = useStore(authState);

  return (
    <div>
      <div>点左面的菜单</div>
      <div>当前用户 ID:{authData.userId}</div>
      <div>当前用户 :{authData.userName}</div>
    </div>
  );
}

export default function ContentRouter() {
  return (
    <Routes>
      <Route path="/" element={<RenderUserGuide />} />
      <Route path="/user/user_management" element={<UserManagement />} />
      <Route path="/user/user_info" element={<UserInfo />} />
      <Route path="/user/user_cheat_ban" element={<CheatBan />} />
      <Route path="/user/user_cheat_ban_table" element={<CheatBanTable />} />
      <Route path="/user/ladder_limit" element={<LadderLimit />} />
      <Route path="/user/sensitive_risk" element={<SensitiveRiskPage />} />
      <Route path="/cheat/process_data" element={<CheatProcessData />} />
      <Route path="/cheat/suspicious_info" element={<SuspiciousInfoPage />} />
      <Route path="/cheat/user_teammate_count" element={<CheatUserTeammateCount />} />
      <Route path="/replay/collect" element={<ReplayCollectPage />} />
      <Route path="/replay/game_name_lookup" element={<ReplayGameNameLookupPage />} />
      <Route path="/auto_ban/auto_ban_status" element={<AutoBanStatus />} />
      <Route path="/auto_ban/user_list_by_uuid" element={<UserListByUUID />} />
      <Route path="/system/update_token" element={<SystemToken />} />
      <Route path="/system/mpq" element={<MpqManager />} />
      <Route path="/system/gray_config" element={<GrayConfigPage />} />
      <Route path="/system/update" element={<UpdateManagerPage />} />
    </Routes>
  );
}
